import React, {useCallback} from 'react';
import type {AstView, EnrichedAstNode} from 'rendition-core';

import {useMultiNodeValue} from 'Hooks/useMultiNodeValue';
import {EditorSectionTitle} from './EditingTitle';
import TabbedButtonToggle from 'Components/Tailwind/TabbedButtonToggle';
import {segmentedControlClassNames} from 'Views/Preview/Builder/EditControls';

interface Props {
    view: AstView;
    setView: (view: AstView) => void;
    selectedNodes: EnrichedAstNode[];
}

const options: Array<{value: string; icon: React.ReactNode}> = [
    {value: 'block', icon: 'Block'},
    {value: 'absolute', icon: 'Absolute'},
];

export const DisplayToggle: React.FC<React.PropsWithChildren<Props>> = ({selectedNodes}) => {
    const accessFn = useCallback(
        (n: EnrichedAstNode) => (n.calculatedLayoutAbstraction.absolutePosition ? 'absolute' : 'block'),
        []
    );
    const assignFn = useCallback((n: EnrichedAstNode, v: React.CSSProperties['display']) => {
        if (v === 'absolute') {
            n.inputLayoutAbstraction.absolutePosition = true;
        } else if (v === 'block') {
            n.inputLayoutAbstraction.absolutePosition = false;
        }
        n.meta.systemGenerated = false;
    }, []);

    const {value, updateNodes} = useMultiNodeValue(selectedNodes, accessFn, assignFn, undefined, {
        repairMode: 'tryLock',
    });

    return (
        <div className="flex items-center justify-between">
            <EditorSectionTitle title={'Display'} />
            <TabbedButtonToggle
                classNames={segmentedControlClassNames}
                value={value}
                items={options}
                onClick={updateNodes as (value: React.CSSProperties['display']) => void}
            />
        </div>
    );
};
